// extracted by mini-css-extract-plugin
module.exports = {"mosaicButlletins":"mosaicbutlletins_mosaicButlletins__uG0fj"};